<template>
  <div class="colors" ref="colorcarousel">
      <div
        v-for="(o, index) in $store.state.productInfo.palettecolors"
        :key="o.flossId"
        :data-index="index"
        v-on:click="changeColor(o.flossId, o.flossHtml)"
        v-bind:class="['color', { selected: o.flossId == selectedflossId }]"
        :ref="'color-' + o.flossId"
      >
        <div v-bind:style="{ backgroundColor: '#' + o.flossHtml }"></div>
        <label>
          {{ o.flossName }}
          <!--{{o.flossHtml}} {{o.flossId}}-->
        </label>
      </div>
  </div>
</template>

<script>
export default {
  name: "PaletteColors",
  data() {
    return {
      selectedflossId: Number,
    };
  },
  props: {
    flossId: Number,
    productInfo: Object,
  },
  methods: {
    changeColor(pcId, pcHex) {
      this.selectedflossId = pcId;
      this.$emit("change-color", pcId, pcHex);
    },
  },
  computed: {},
  mounted: function () {
    this.selectedflossId = this.flossId;
  },
  components: {  },
};
</script>
<style>
    .colors {
        display: flex;
        margin: 1em;
        gap: .5em;
        flex-wrap: wrap;
        height: unset;
    }

    .color {

        cursor: pointer;
        /* min-width: 3em; */
        width: calc(16.667% - .44em);
    }
.color:hover > div {
  outline-color: #666;
}
.color.selected > div {
  outline-color: #666;
}
.color > div {
  position: relative;
  /* overflow: hidden; */
  height: 2.5em;
  border-radius: 2px;
  border: solid 1px #fff;
  outline: solid 1px #ccc;
}

    @media only screen and (max-width: 750px) {
        .color {
            max-width: unset;
        }
    }

.color label {
  display: none;
}

.color:hover label {
  font-size: 0.7rem;
  padding: 0.5em 0 0;
  width: calc(100% + 4em);
  line-height: 1.15em;
  /* white-space: nowrap; */
  /* border: solid 1px; */
  text-align: center;
  position: absolute;
  left: 50%;
  top: 4.25em;
  transform: translateX(-50%);
  /*display: block;*/
  /* border: solid 1px; */
}
.color:hover label {
  color: #b1b0a5;
}

button.slick-arrow {
  top: calc(50% - 1.2rem);
}
</style>
